import type { LogRouter } from "@pandas/logger";
import { GetLogger, LogLevel, SetDefaultLogger } from "@pandas/logger";
import { servicesOrchestratorValues } from "../../config/services";
import { useStore } from "../../store";

let logger: LogRouter;

const axiomDataset = servicesOrchestratorValues.credentials.axiom.dataset;
const axiomToken = servicesOrchestratorValues.credentials.axiom.token;
const axiomOrgId = servicesOrchestratorValues.credentials.axiom.orgId;
const rawEnv = servicesOrchestratorValues.app.env ?? "develop";
const nodeEnv = rawEnv === "development" ? "develop" : rawEnv;
const projectId = "retail-app";
let sendLogsToAxiomBelowLevel = LogLevel.debug;
if (nodeEnv === "develop" || nodeEnv === "staging") {
	sendLogsToAxiomBelowLevel = LogLevel.trace;
}
if (nodeEnv === "uat" || nodeEnv === "production" || nodeEnv === "staging" || nodeEnv === "develop") {
	logger = GetLogger(nodeEnv, projectId, axiomToken, axiomOrgId, axiomDataset, sendLogsToAxiomBelowLevel);
	SetDefaultLogger(logger);

	useStore.subscribe(
		(state) => state.sessionId,
		(sessionId) => {
			logger.injectCommonProp("pandas_session_id", sessionId ?? "");
		},
	);

	useStore.subscribe(
		(state) => state.deviceInfo.imei,
		(imei) => {
			// The validated device identifier ships in full: one log-content rule for both
			// estates (a device attribute, not customer identity), so v1 lines join v2's.
			logger.injectCommonProp("pandas_identifier", imei ?? "");
		},
	);
} else {
	throw new Error("Invalid environment configuration for logger");
}
export default logger;
